/**
 * Профиль психолога
 * Inline-обработчики, flatpickr, TinyMCE
 */
var PsyProfile = {
	moduleId: null,

	/**
	 * Инициализация
	 */
	init: function() {
		var container = document.querySelector('[data-psy-profile-module-id]');
		if (!container) return;

		this.moduleId = container.dataset.psyProfileModuleId;
		this.initFlatpickr();
		this.initTinyMCE();
	},

	/**
	 * Инициализация flatpickr для полей дат
	 */
	initFlatpickr: function() {
		if (typeof flatpickr === 'undefined') return;

		var dateInputs = document.querySelectorAll('.psy-cabinet [data-flatpickr]');
		dateInputs.forEach(function(input) {
			flatpickr(input, {
				// VForm ожидает d.m.Y, и SimpleModule отдаёт DTE_-поля в этом же формате
				dateFormat: 'd.m.Y',
				allowInput: true
			});
		});
	},

	/**
	 * Инициализация TinyMCE для поля биографии
	 */
	initTinyMCE: function() {
		if (typeof tinymce === 'undefined') return;

		var bioTextarea = document.querySelector('.psy-cabinet textarea[name="htm_bio"]');
		if (!bioTextarea) return;

		tinymce.init({
			target: bioTextarea,
			language: 'ru',
			height: 300,
			menubar: false,
			statusbar: false,
			plugins: 'lists link',
			toolbar: 'undo redo | cut copy paste | bold italic underline | bullist numlist | link | removeformat',
			contextmenu: 'cut copy paste | link',

			// Белый список форматов — ровно то, что есть в тулбаре.
			// Всё остальное (font, span style, h1-h6, table, color, font-size, mso-*) выкидывается.
			valid_elements: 'p,br,strong/b,em/i,u,ul,ol,li,a[href|target|rel]',
			valid_styles: {},          // запрещаем любые inline-стили
			invalid_styles: '*',       // дублирующая защита: ни один style= не пройдёт

			// Очистка вставки из Word: стрипает классы Mso*, теги <o:p>, инлайн-стили
			paste_as_text: false,      // оставляем форматирование bold/italic/списков
			paste_data_images: false,
			paste_remove_styles_if_webkit: true,
			paste_merge_formats: true,
			paste_webkit_styles: 'none',
			paste_retain_style_properties: 'none',
			skin: false,
			content_css: '/rich-text.css?v1.1',
			branding: false,
			promotion: false,
			license_key: 'gpl'
		});
	},

	// =========================================================================
	// ФОРМЫ (inline onsubmit)
	// =========================================================================

	/**
	 * Сохранение профиля (inline)
	 */
	saveProfile: function(form) {
		// Синхронизируем TinyMCE с textarea перед отправкой
		if (typeof tinymce !== 'undefined') {
			tinymce.triggerSave();
		}

		var formData = new FormData(form);
		formData.append('action', 'save');

		var submitBtn = form.querySelector('button[type="submit"]');
		this.setLoading(submitBtn, true);

		var self = this;
		fetch('/ajax.php?mid=' + this.moduleId, {
			method: 'POST',
			body: formData
		})
		.then(function(r) { return r.json(); })
		.then(function(res) {
			if (res.success) {
				self.showNotification('Профиль сохранён', 'success');
				// Обновляем фото если загружалось новое
				if (res.photo) {
					var photoWrap = form.querySelector('.psy-profile__photo');
					if (photoWrap) {
						photoWrap.querySelector('img').src = res.photo + '?t=' + Date.now();
					} else {
						var fileInput = form.querySelector('[name="img_photo"]');
						if (fileInput) {
							var wrap = document.createElement('div');
							wrap.className = 'psy-profile__photo';
							var img = document.createElement('img');
							img.src = res.photo + '?t=' + Date.now();
							img.alt = 'Фото';
							wrap.appendChild(img);
							fileInput.parentNode.insertBefore(wrap, fileInput);
						}
					}
				}
			} else {
				self.showNotification(res.error || 'Ошибка сохранения', 'error');
			}
		})
		.catch(function() {
			self.showNotification('Ошибка соединения', 'error');
		})
		.finally(function() {
			self.setLoading(submitBtn, false);
		});
		return false;
	},

	saveNotifications: function(form) {
		var formData = new FormData(form);
		formData.append('action', 'save_notifications');

		var submitBtn = form.querySelector('button[type="submit"]');
		this.setLoading(submitBtn, true);

		var self = this;
		fetch('/ajax.php?mid=' + this.moduleId, {
			method: 'POST',
			body: formData
		})
		.then(function(r) { return r.json(); })
		.then(function(res) {
			if (res.success) {
				self.showNotification('Настройки уведомлений сохранены', 'success');
			} else {
				self.showNotification(res.error || 'Ошибка сохранения', 'error');
			}
		})
		.catch(function() {
			self.showNotification('Ошибка соединения', 'error');
		})
		.finally(function() {
			self.setLoading(submitBtn, false);
		});
		return false;
	},

	/**
	 * Смена пароля (inline)
	 */
	changePassword: function(form) {
		var formData = new FormData(form);
		formData.append('action', 'change_password');

		var submitBtn = form.querySelector('button[type="submit"]');
		this.setLoading(submitBtn, true);

		var self = this;
		fetch('/ajax.php?mid=' + this.moduleId, {
			method: 'POST',
			body: formData
		})
		.then(function(r) { return r.json(); })
		.then(function(res) {
			if (res.success) {
				self.showNotification('Пароль изменён', 'success');
				form.reset();
			} else {
				self.showNotification(res.error || 'Ошибка', 'error');
			}
		})
		.catch(function() {
			self.showNotification('Ошибка соединения', 'error');
		})
		.finally(function() {
			self.setLoading(submitBtn, false);
		});
		return false;
	},

	// =========================================================================
	// ОБРАЗОВАНИЕ
	// =========================================================================

	/**
	 * Открыть попап образования (загрузка контента с сервера)
	 */
	openEducationPopup: function(itemId) {
		var popup = document.getElementById('popup-psy-education');
		if (!popup) return;

		var content = popup.querySelector('.popup__content');
		var title = popup.querySelector('.popup__title');

		// Показываем загрузку
		content.innerHTML = '<div class="psy-profile__loading">Загрузка...</div>';
		title.textContent = itemId ? 'Редактировать образование' : 'Добавить образование';
		popup.classList.add('active');

		// Загружаем форму с сервера
		var self = this;
		fetch('/ajax.php?mid=' + this.moduleId + '&action=get_education_popup&id=' + (itemId || 0))
			.then(function(r) { return r.text(); })
			.then(function(html) {
				content.innerHTML = html;
			})
			.catch(function() {
				content.innerHTML = '<div class="psy-profile__error">Ошибка загрузки</div>';
			});
	},

	/**
	 * Сохранение образования (inline)
	 */
	saveEducation: function(form) {
		var formData = new FormData(form);
		formData.append('action', 'save_education');

		var submitBtn = form.querySelector('button[type="submit"]');
		this.setLoading(submitBtn, true);

		var self = this;
		fetch('/ajax.php?mid=' + this.moduleId, {
			method: 'POST',
			body: formData
		})
		.then(function(r) { return r.json(); })
		.then(function(res) {
			if (res.success) {
				self.closePopups();
				self.refreshPage();
			} else {
				self.showNotification(res.error || 'Ошибка', 'error');
			}
		})
		.finally(function() {
			self.setLoading(submitBtn, false);
		});
		return false;
	},

	/**
	 * Удаление образования
	 */
	deleteEducation: function(itemId) {
		if (!confirm('Удалить эту запись?')) return;

		var self = this;
		this.ajax('delete_education', { id: itemId })
			.then(function(res) {
				if (res.success) {
					self.refreshPage();
				} else {
					self.showNotification(res.error || 'Ошибка', 'error');
				}
			});
	},

	// =========================================================================
	// РАСПИСАНИЕ
	// =========================================================================

	/**
	 * Открыть попап расписания
	 */
	openSchedulePopup: function(itemId) {
		var popup = document.getElementById('popup-psy-schedule');
		if (!popup) return;

		var form = document.getElementById('psy-schedule-form');
		var title = popup.querySelector('.popup__title');

		form.reset();
		form.querySelector('[name="id"]').value = '';

		if (itemId) {
			title.textContent = 'Редактировать слот';
			this.loadScheduleItem(itemId, form);
		} else {
			title.textContent = 'Добавить слот';
		}

		popup.classList.add('active');
	},

	/**
	 * Загрузка данных слота
	 */
	loadScheduleItem: function(itemId, form) {
		this.ajax('get_schedule_item', { id: itemId })
			.then(function(res) {
				if (res.success && res.item) {
					form.querySelector('[name="id"]').value = res.item.id;
					form.querySelector('[name="sel_weekday"]').value = res.item.weekday || '';
					form.querySelector('[name="str_time_start"]').value = res.item.time_start || '';
					form.querySelector('[name="str_time_end"]').value = res.item.time_end || '';
					form.querySelector('[name="sel_format"]').value = res.item.format || '';
					form.querySelector('[name="slt_psy_locations"]').value = res.item.location_id || '';
					form.querySelector('[name="chk_active"]').checked = res.item.active == 1;
				}
			});
	},

	/**
	 * Сохранение расписания (inline)
	 */
	saveScheduleItem: function(form) {
		var formData = new FormData(form);
		formData.append('action', 'save_schedule_item');

		var submitBtn = form.querySelector('button[type="submit"]');
		this.setLoading(submitBtn, true);

		var self = this;
		fetch('/ajax.php?mid=' + this.moduleId, {
			method: 'POST',
			body: formData
		})
		.then(function(r) { return r.json(); })
		.then(function(res) {
			if (res.success) {
				self.closePopups();
				self.refreshPage();
			} else {
				self.showNotification(res.error || 'Ошибка', 'error');
			}
		})
		.finally(function() {
			self.setLoading(submitBtn, false);
		});
		return false;
	},

	/**
	 * Удаление слота расписания
	 */
	deleteScheduleItem: function(itemId) {
		if (!confirm('Удалить этот слот?')) return;

		var self = this;
		this.ajax('delete_schedule_item', { id: itemId })
			.then(function(res) {
				if (res.success) {
					self.refreshPage();
				} else {
					self.showNotification(res.error || 'Ошибка', 'error');
				}
			});
	},

	// =========================================================================
	// ВСПОМОГАТЕЛЬНЫЕ
	// =========================================================================

	/**
	 * Закрытие попапов
	 */
	closePopups: function() {
		document.querySelectorAll('.popup-psy-profile').forEach(function(popup) {
			popup.classList.remove('active');
		});
	},

	/**
	 * Обновление страницы
	 */
	refreshPage: function() {
		location.reload();
	},

	/**
	 * AJAX запрос
	 */
	ajax: function(action, data) {
		data = data || {};
		var formData = new FormData();
		formData.append('action', action);

		for (var key in data) {
			formData.append(key, data[key]);
		}

		return fetch('/ajax.php?mid=' + this.moduleId, {
			method: 'POST',
			body: formData
		}).then(function(r) { return r.json(); });
	},

	/**
	 * Показать уведомление
	 */
	showNotification: function(message, type) {
		if (type === 'error') {
			alert('Ошибка: ' + message);
		} else {
			// Простое уведомление
			var notif = document.createElement('div');
			notif.className = 'psy-notification psy-notification--success';
			notif.textContent = message;
			document.body.appendChild(notif);
			setTimeout(function() { notif.remove(); }, 3000);
		}
	},

	/**
	 * Состояние загрузки кнопки
	 */
	setLoading: function(button, loading) {
		if (!button) return;

		if (loading) {
			button.disabled = true;
			button.dataset.originalText = button.textContent;
			button.textContent = 'Сохранение...';
		} else {
			button.disabled = false;
			button.textContent = button.dataset.originalText || button.textContent;
		}
	}
};

// Инициализация при загрузке DOM
$(document).ready(function() {
	PsyProfile.init();
});

window.PsyProfile = PsyProfile;
